class CrocsLoyaltyModal extends HTMLElement {
	constructor() {
		super();
		this.modalContainer = null;
		this.overlay = null;
		this.closeButton = null;
		this.currentStep = null;
		this.steps = [];
		this.selectors = {
			otpInputField: '.otp-input-field',
			overlay: '.overlay',
			modalContainer: '.modal-container',
			submitBtn: '.submit_loyalty_register',
			phoneField: '.input_field',
			requiredValueField: 'input.required_value',
			closeBtn: '.close-modal',
		};
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.modalContainer = this.querySelector('.loyalty-modal');
		this.overlay = this.querySelector('.overlay');
		this.closeButton = this.querySelectorAll(
			'[data-active="close-modal"], .close-modal'
		);
		this.steps = this.querySelectorAll('.modal-step');

		if (this.closeButton) {
			this.closeButton.forEach((button) => {
				button.addEventListener('click', () => this.closeModal());
			});
		}

		if (this.overlay) {
			this.overlay.addEventListener('click', () => {
				if (window.location.pathname.includes('/account/login')) return;
				this.closeModal();
			});
		}

		this.hidePassword();
	}

	openModal() {
		document.documentElement.classList.add('show-modal', 'no-scroll');
		this.currentStep = this.steps[0];
		this.updateModalStep();
		this.otpInputFieldChanged();
	}

	closeModal() {
		const voucherContainer = document.querySelector(
			'.voucher-card .voucher-card-list.voucher-items'
		);

		const walletContainer = document.querySelector('.wallet-summary-box');
		if (voucherContainer) {
			voucherContainer.classList.add('close-voucher');
		}

		if (walletContainer) {
			walletContainer.classList.add('close-voucher');
		}

		document.documentElement.classList.remove('show-modal', 'no-scroll');
		this.classList.remove('active');

		const modalContent = this.querySelector('.loyalty-modal');
		if (modalContent.classList.contains('voucher')) {
			setTimeout(() => {
				modalContent.classList.remove('voucher');
			}, 700);

			setTimeout(() => {
				if (voucherContainer) {
					voucherContainer.classList.remove('close-voucher');
				}
				if (walletContainer) {
					walletContainer.classList.remove('close-voucher');
				}
			}, 1000);
		} else {
			if (voucherContainer) {
				voucherContainer.classList.remove('close-voucher');
			}
			if (walletContainer) {
				walletContainer.classList.remove('close-voucher');
			}
		}
	}

	hidePassword() {
		const hideIcon = this.querySelectorAll('.field-icon');

		hideIcon.forEach((icon) => {
			icon.addEventListener('click', () => {
				const targetId = icon.getAttribute('data-target');
				const pinField = document.querySelector(targetId);
				const siblingIcon =
					icon.nextElementSibling || icon.previousElementSibling;

				if (pinField) {
					const isPasswordHidden = pinField.type === 'password';

					pinField.type = isPasswordHidden ? 'text' : 'password';

					icon.style.display = 'none';

					if (siblingIcon) {
						siblingIcon.style.display = 'inline-block';
					}
					setTimeout(() => {
						siblingIcon.addEventListener('click', () => {
							icon.style.display = 'inline-block';
							siblingIcon.style.display = 'none';
						});
					}, 100);
				} else {
					console.error('Không tìm thấy pinField!');
				}
			});
		});
	}
}

customElements.define('crocs-loyalty-modal', CrocsLoyaltyModal);
